import { render, staticRenderFns } from "./AutoSendConfirm.vue?vue&type=template&id=62d18a97&scoped=true"
import script from "./AutoSendConfirm.vue?vue&type=script&lang=js"
export * from "./AutoSendConfirm.vue?vue&type=script&lang=js"
import style0 from "./AutoSendConfirm.vue?vue&type=style&index=0&id=62d18a97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d18a97",
  null
  
)

export default component.exports